import { apiSlice } from 'api/apiSlice'
import { HistoricalOrder } from 'shared/types/HistoricalOrder'

const ordersApi = apiSlice.injectEndpoints({
  endpoints: build => ({
    getHistoricalOrders: build.query<{ orders: HistoricalOrder[] }, number | void>({
      providesTags: ['Order'],
      query: (page = 1) => ({
        app: 'sneakers',
        method: 'GET',
        url: `/web-api/v1/flight_club_historical_orders?page=${page}&timestamp=${new Date().getTime()}`,
      }),
    }),
    getOrder: build.query({
      providesTags: ['Order'],
      query: orderNumber => ({
        app: 'sneakers',
        cache: false,
        method: 'GET',
        url: `/web-api/v1/orders/${orderNumber}?includeCredits=true&timestamp=${new Date().getTime()}`,
      }),
    }),
    requestOrderTransfer: build.mutation({
      query: orderNumber => ({
        app: 'sneakers',
        method: 'PUT',
        url: `/web-api/v1/orders/${orderNumber}/request_order_transfer`,
      }),
    }),
    updateOrderStatus: build.mutation({
      invalidatesTags: ['Order'],
      query: ({ orderNumber, ...body }) => ({
        app: 'sneakers',
        data: body,
        method: 'PUT',
        url: `/web-api/v1/orders/${orderNumber}/update_status`,
      }),
    }),
  }),
})

export const {
  useGetHistoricalOrdersQuery,
  useGetOrderQuery,
  useRequestOrderTransferMutation,
  useUpdateOrderStatusMutation,
} = ordersApi
